import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "news"
};
const _hoisted_2 = {
  class: "news_content"
};
const _hoisted_3 = ["src"];
import { ref, onMounted, onUnmounted, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const themeVars = {
      navBarIconColor: '#000'
    };
    console.log(route);
    const query = route.query.url; // 获取查询参数

    const goindex = () => {
      router.push({
        path: '/index'
      });
    };
    onMounted(() => {});
    onUnmounted(() => {});
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_config_provider, {
        "theme-vars": themeVars
      }, {
        default: _withCtx(() => [_createVNode(_component_van_nav_bar, {
          "left-arrow": "",
          onClickLeft: _cache[0] || (_cache[0] = $event => goindex()),
          onClickRight: _cache[1] || (_cache[1] = $event => goindex())
        }, {
          right: _withCtx(() => [_createVNode(_component_van_icon, {
            name: "cross",
            size: "18"
          })]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("iframe", {
        class: "iframe_content",
        src: _unref(query),
        frameborder: "0"
      }, null, 8, _hoisted_3)])]);
    };
  }
};